export default "dist/images/block-accordion-line-colored-hover.7d6772b.png";